module.exports = __webpack_public_path__ + "img/CM-SL-CA-Honda-Lifestyle.45cd3366.jpeg";